import { gql } from '@apollo/client';

export default gql`
  query getTrialBalance($start: Date, $end: Date, $byItems: Boolean) {
    getTrialBalance(start: $start, end: $end, byItems: $byItems) {
      ok
      error
      data
    }
  }
`;
